import { Box, Center, Text, Icon } from '@chakra-ui/react';
import { ReactNode, useEffect, useState } from 'react';

import AttachmentIcon from './assets/attachment.svg?react';

interface FileDropZoneProps {
  children: ReactNode;
  onFilesDropped: (files: File[]) => void;
  disableDropZone?: boolean;
}

export function FileDropZone({
  children,
  onFilesDropped,
  disableDropZone = false,
}: FileDropZoneProps) {
  const [isDraggingFile, setIsDraggingFile] = useState(false);

  useEffect(() => {
    if (disableDropZone) {
      return;
    }

    let dragCounter = 0;

    const handleDragEnter = (e: DragEvent) => {
      e.preventDefault();
      dragCounter++;

      if (e.dataTransfer?.types.includes('Files')) {
        setIsDraggingFile(true);
      }
    };

    const handleDragOver = (e: DragEvent) => {
      e.preventDefault();
    };

    const handleDragLeave = (e: DragEvent) => {
      e.preventDefault();
      dragCounter--;

      if (dragCounter === 0) {
        setIsDraggingFile(false);
      }
    };

    const handleDrop = (e: DragEvent) => {
      e.preventDefault();
      dragCounter = 0;
      setIsDraggingFile(false);

      if (e.dataTransfer?.files.length) {
        const filesArray = Array.from(e.dataTransfer.files);
        onFilesDropped(filesArray);
      }
    };

    document.addEventListener('dragenter', handleDragEnter);
    document.addEventListener('dragover', handleDragOver);
    document.addEventListener('dragleave', handleDragLeave);
    document.addEventListener('drop', handleDrop);

    return () => {
      document.removeEventListener('dragenter', handleDragEnter);
      document.removeEventListener('dragover', handleDragOver);
      document.removeEventListener('dragleave', handleDragLeave);
      document.removeEventListener('drop', handleDrop);
    };
  }, [onFilesDropped, disableDropZone]);

  return (
    <Box position="relative" width="100%" height="100%">
      {children}

      {isDraggingFile && (
        <Box
          position="absolute"
          top={0}
          left={0}
          right={0}
          bottom={0}
          bg="rgba(88, 122, 255, 0.1)"
          border="2px dashed"
          borderColor="main"
          borderRadius="md"
          zIndex={9999}
          pointerEvents="none"
        >
          <Center height="100%">
            <Box textAlign="center" color="main">
              <Icon as={AttachmentIcon} boxSize="48px" />
              <Text fontSize="xl" fontWeight="bold" mt={4}>
                Drop files to upload
              </Text>
            </Box>
          </Center>
        </Box>
      )}
    </Box>
  );
}
